export const ActionTypes = {
	SET_RUNTIME_VARIABLE: "SET_RUNTIME_VARIABLE",

	TOGGLE_SIDEBAR: "TOGGLE_SIDEBAR",
	OPEN_SIDEBAR: "OPEN_SIDEBAR",
	CLOSE_SIDEBAR: "CLOSE_SIDEBAR",

	FETCH_SIDECHAINS_REQUEST: "FETCH_SIDECHAINS_REQUEST",
	FETCH_SIDECHAINS_SUCCESS: "FETCH_SIDECHAINS_SUCCESS",
	FETCH_SIDECHAINS_FAILURE: "FETCH_SIDECHAINS_FAILURE",
	CREATE_SIDECHAIN_REQUEST: "CREATE_SIDECHAIN_REQUEST",
	ADD_SIDECHAIN_TO_LIST: "ADD_SIDECHAIN_TO_LIST",
	CREATE_SIDECHAIN_FAILURE: "CREATE_SIDECHAIN_FAILURE",
	UPDATE_SIDECHAIN: "UPDATE_SIDECHAIN",
	CONNECT_SIDECHAIN: "CONNECT_SIDECHAIN",
	JOIN_SIDECHAIN_SUCCESS: "JOIN_SIDECHAIN_SUCCESS",
	UPDATE_USER_DETAILS: "UPDATE_USER_DETAILS",

	SET_SIDECHAIN: "SET_SIDECHAIN",

	CREATE_GENESIS_REQUEST: "CREATE_GENESIS_REQUEST",
	CREATE_GENESIS_SUCCCESS: "CREATE_GENESIS_SUCCCESS",

	FETCH_PERMISSIONS: "FETCH_PERMISSIONS",

	FETCH_NODES_REQUEST: "FETCH_NODES_REQUEST",
	FETCH_NODES_SUCCESS: "FETCH_NODES_SUCCESS",
	FETCH_NODES_FAILURE: "FETCH_NODES_FAILURE",
	CREATE_NODE_REQUEST: "CREATE_NODE_REQUEST",
	CREATE_NODE_SUCCCESS: "CREATE_NODE_SUCCCESS",
	CREATE_NODE_FAILURE: "CREATE_NODE_FAILURE",
	CREATE_NODE_TO_LAUNCH: "CREATE_NODE_TO_LAUNCH",
	UPDATE_NODE: "UPDATE_NODE",

	CREATE_SCOPE_SUCCCESS: "CREATE_SCOPE_SUCCCESS",
	UPDATE_SCOPE_SUCCCESS: "UPDATE_SCOPE_SUCCCESS",
	CREATE_SCOPE_FAILURE: "CREATE_SCOPE_FAILURE",

	FETCH_TABLES_REQUEST: "FETCH_TABLES_REQUEST",
	FETCH_TABLES_SUCCESS: "FETCH_TABLES_SUCCESS",
	FETCH_TABLES_FAILURE: "FETCH_TABLES_FAILURE",

	FETCH_ROLE_USERS_SUCCESS: "FETCH_ROLE_USERS_SUCCESS",
	DELETE_ROLES: "DELETE_ROLES",
	DELETE_USER_ROLE: "DELETE_USER_ROLE",

	UPDATE_TASK_SUCCCESS: "UPDATE_TASK_SUCCCESS",
	CREATE_TASK_SUCCCESS: "CREATE_TASK_SUCCCESS",

	UPDATE_ROLE_SUCCCESS: "UPDATE_ROLE_SUCCESS",
	CREATE_ROLE_SUCCCESS: "CREATE_ROLE_SUCCCESS",

	FETCH_USERS_SUCCESS: "FETCH_USERS_SUCCESS",
	UPDATE_USER: "UPDATE_USER",

	LOGIN_SUCCESS: "LOGIN_SUCCESS",
	LOGIN_REQUEST: "LOGIN_REQUEST",
	LOGOUT_SUCCESS: "LOGOUT_SUCCESS",
	LOGIN_FAILURE: "LOGIN_FAILURE",
	SET_USER_KEYS: "SET_USER_KEYS",

	UPDATE_ORACLE_SUCCCESS: "UPDATE_ORACLE_SUCCESS",
	CREATE_ORACLE_SUCCCESS: "CREATE_ORACLE_SUCCCESS",

	SET_DEMO_DATA: "SET_DEMO_DATA",

	CREATE_ACCOUNT_SUCCESS: "CREATE_ACCOUNT_SUCCESS",
	CREATE_ACCOUNT_FAILURE: "CREATE_ACCOUNT_FAILURE",

	CREATE_FEE_FAILURE: "CREATE_FEE_FAILURE",

	// Market
	FETCH_LISTINGS_REQUEST: "FETCH_LISTINGS_REQUEST",
	MARKET_LOGOUT_SUCCESS: "MARKET_LOGOUT_SUCCESS",
	MARKET_LOGIN_SUCCESS: "MARKET_LOGIN_SUCCESS",
	MARKET_FETCH_LISTINGS_SUCCESS: "MARKET_FETCH_LISTINGS_SUCCESS",
	MARKET_GET_LISTING_SUCCESS: "MARKET_GET_LISTING_SUCCESS",
	MARKET_SET_PREVIEW_LISTING: "MARKET_SET_PREVIEW_LISTING",
	MARKET_UPDATE_LISTING: "MARKET_SAVE_LISTING",
};
